/**
 * Functionality for the mobile slider
 */

const MobileSlider = ($) => {
	/**
	 * * Create the settings for the mobile-only slider
	 */
	const settings = {
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 4000,
		dots: true,
		arrows: false,
		mobileFirst: true,
		responsive: [
			{
				breakpoint: 767,
				settings: "unslick",
			},
		],
	};

	/**
	 * * Initialize mobile slider
	 */

	const mobileSlider = $("#js-slider-mobile-only").slick(settings);

	/**
	 * * Initialize mobile slider if window width is less than tablet, and it hasn't
	 * * already been initialized (ie, it was 'unslicked')
	 */

	$(window).on("resize", function () {
		if (
			$(window).width() < 767 &&
			!mobileSlider.hasClass("slick-initialized")
		) {
			$("#js-slider-mobile-only").slick(settings);
		}
	});
};

export default MobileSlider;
